import { Tabs } from "@shared/ui/tabs";
import { PendingServiceOrders } from "../pending/PendingServiceOrders";
import { AssignedServiceOrders } from "../assigned/AssignedServiceOrders";
import { CompletedServiceOrders } from "../completed/CompletedServiceOrders";
import { HistoryServiceOrders } from "../history/HistoryServiceOrders";
import { Activity, Users, CheckCircle2, Clock, XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useAreaConfig, useServiceAssociations } from "../../hooks";
import RejectionList from "../rejected/rejectedServiceOrder";

const Landing = () => {
  const navigate = useNavigate();

  useAreaConfig();
  useServiceAssociations();

  // Create tab components with stable references
  const tabComponents = useMemo(() => {
    return {
      pending: {
        label: "Pending Service Orders",
        icon: <Clock className="h-4 w-4" />,
        component: (
          <PendingServiceOrders
            key="pending-orders"
            onCreateServiceOrder={() =>
              navigate("/service-orders/wx-dashboard/create-service-order")
            }
          />
        ),
      },
      assigned: {
        label: "Assigned Service Orders",
        icon: <Users className="h-4 w-4" />,
        component: <AssignedServiceOrders key="assigned-orders" />,
      },
        rejected: {
        label: "Rejected Service Orders",
        icon: <XCircle className="h-4 w-4" />,
        component: <RejectionList key="rejected-orders" />,
      },
      completed: {
        label: "Completed Service Orders",
        icon: <CheckCircle2 className="h-4 w-4" />,
        component: <CompletedServiceOrders key="completed-orders" />,
      },
      history: {
        label: "History Service Orders",
        icon: <Activity className="h-4 w-4" />,
        component: <HistoryServiceOrders key="history-orders" />,
      },
    };
  }, [navigate]);

  return (
    <div className=" bg-white">
      <div className="flex items-center space-x-4 pb-4">
        <div>
          <h1 className="page-title">
            Dispatcher
          </h1>
          <p className="page-subtitle">
            Unified dispatch management interface with real-time visibility
          </p>
        </div>
      </div>

      <Tabs
        defaultValue="pending"
        className="space-y-6"
        urlMapping={{
          pending: "pending",
          assigned: "assigned",
          completed: "completed",
          history: "history",
        }}
        disableUrlSync={false}
        idPrefix="service-orders"
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-5 p-1"
      />
    </div>
  );
};

export default Landing;
